/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeAPIKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RevokeAPIKeyRequest = {
  /**
   * The ID of the key to revoke
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type RevokeAPIKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RevokeAPIKeySecurity$outboundSchema: z.ZodMiniType<
  RevokeAPIKeySecurity$Outbound,
  RevokeAPIKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function revokeAPIKeySecurityToJSON(
  revokeAPIKeySecurity: RevokeAPIKeySecurity,
): string {
  return JSON.stringify(
    RevokeAPIKeySecurity$outboundSchema.parse(revokeAPIKeySecurity),
  );
}

/** @internal */
export type RevokeAPIKeyRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const RevokeAPIKeyRequest$outboundSchema: z.ZodMiniType<
  RevokeAPIKeyRequest$Outbound,
  RevokeAPIKeyRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function revokeAPIKeyRequestToJSON(
  revokeAPIKeyRequest: RevokeAPIKeyRequest,
): string {
  return JSON.stringify(
    RevokeAPIKeyRequest$outboundSchema.parse(revokeAPIKeyRequest),
  );
}
